import React, { useState } from "react";
import PageHeader from "./PageHeader";
import ContentBuckets from "./ContentBuckets";
import LearningPathCanvas from "./LearningPathCanvas";
import MediaLibrary from "./MediaLibrary";
import AddResoursePanel from "./AddResoursePanel";
import { useNavigate } from "react-router";
import { useMutation, useQuery } from "react-query";
import toast from "react-hot-toast";
import { api } from "../../../../../../../../api/learningPath";
import AllAddedResources from "./AllAddedResources";

// interface PathItem {
//   id: string;
//   title: string;
//   description?: string;
//   duration: string;
//   type: "course" | "assessment";
//   questions?: number;
// }

const PathContent = () => {
  const [selectedCourses, setSelectedCourses] = useState([]);
  const [addCourseModal, setAddCourseModal] = useState(false);
  const [settingsModal, setSettingsModal] = useState(false);

  const [pathItems, setPathItems] = useState([]);
  const [activeView, setActiveView] = useState("path");

  const navigate = useNavigate();
  const user = JSON.parse(sessionStorage.getItem("user"));
  const active_path = JSON.parse(sessionStorage.getItem("active-path"));

  const {
    data: resources,
    isLoading,
    refetch,
  } = useQuery(
    ["get-journey-by-id"],
    async () => {
      const response = await api.getIndividualLearningPath({
        org_id: user?.org?.id,
        id: active_path?.id,
      });
      return response.data;
    },
    {
      cacheTime: 100,
      staleTime: 100,
      refetchOnMount: true,
      refetchOnWindowFocus: true,
      onError: (error) => {
        toast.error(error.response.data.message);
      },
      onSuccess: (response) => {
        if (response?.journeyCourses?.length)
          setSelectedCourses(
            response?.journeyCourses?.map((course) => {
              return course?.course;
            })
          );
      },
    }
  );

  const handleAddItem = (item) => {
    const newItem = {
      id: item.id,
      title: item.name || item.title,
      description: item.description || "",
      duration: item.duration || "N/A",
      type: item.type || "course",
      questions: item.questions || 0,
    };

    setPathItems((prev) => {
      if (prev.some((p) => p.id === newItem.id)) return prev;
      return [...prev, newItem];
    });
  };

  const handleRemoveItem = (id) => {
    setPathItems((prev) => prev.filter((item) => item.id !== id));
  };

  const handleMoveUp = (id) => {
    setPathItems((prev) => {
      const index = prev.findIndex((item) => item.id === id);
      if (index > 0) {
        const newItems = [...prev];
        [newItems[index - 1], newItems[index]] = [
          newItems[index],
          newItems[index - 1],
        ];
        return newItems;
      }
      return prev;
    });
  };

  const handleMoveDown = (id) => {
    setPathItems((prev) => {
      const index = prev.findIndex((item) => item.id === id);
      if (index < prev.length - 1) {
        const newItems = [...prev];
        [newItems[index], newItems[index + 1]] = [
          newItems[index + 1],
          newItems[index],
        ];
        return newItems;
      }
      return prev;
    });
  };

  const handlePreview = () => {
    console.log("Preview learning path:", pathItems);
  };

  const handlePublish = () => {
    sessionStorage.removeItem("active-path");
    toast.success("Published successfully...");
    navigate("/admin/learning-path/");
  };

  const handleDrop = (item) => {
    if (!pathItems.find((pathItem) => pathItem.id === item.id)) {
      setPathItems((prev) => [...prev, item]);
    }
  };

  return (
    <div className="min-h-screen bg-gray-100">
      <PageHeader onPreview={handlePreview} onPublish={handlePublish} />
      {/* Tabs for switching views */}
      <div className="flex justify-between items-center bg-white px-6 py-3 border-b border-gray-200">
        <div className="flex space-x-4">
          <button
            onClick={() => setActiveView("path")}
            className={`px-4 py-2 text-sm font-medium rounded ${
              activeView === "path"
                ? "bg-customOrange text-white"
                : "bg-gray-100 text-gray-700"
            }`}
          >
            Learning Path
          </button>
          <button
            onClick={() => setActiveView("resources")}
            className={`px-4 py-2 text-sm font-medium rounded ${
              activeView === "resources"
                ? "bg-customOrange text-white"
                : "bg-gray-100 text-gray-700"
            }`}
          >
            Added Resources
          </button>
        </div>
      </div>

      <div className="flex h-[800px]">
        <ContentBuckets onAddItem={handleAddItem} />
        {/* Middle section: Switchable */}
        {activeView === "path" ? (
          <LearningPathCanvas
            pathItems={pathItems}
            onRemoveItem={handleRemoveItem}
            onMoveUp={handleMoveUp}
            onMoveDown={handleMoveDown}
            onDrop={handleDrop}
          />
        ) : (
          <section className="w-full md:w-[40%] md:mx-auto md:mt-3 flex items-end gap-[10px] justify-center flex-col p-[20px] border-2 border-dotted border-slate-300 rounded-md">
            <div className="items-center justify-between w-full">
              <h1 className="text-sm pb-2 border-b border-gray-200 mb-2">
                Added Resources & Media
              </h1>
              <AllAddedResources
                resources={resources?.resources}
                isLoading={isLoading}
                refetch={refetch}
              />
            </div>
          </section>
        )}
       
        <section className="bg-white w-[30%] p-3 md:mt-3">
          <AddResoursePanel
            refetch={refetch}
            addResource={null}
            processFile={null}
            setShowResourceModal={null}
            fileType={null}
            setFileType={null}
            withTitle={true}
            openPanel={false}
            setModules={null}
            modules={null}
          />
        </section>
      </div>
    </div>
  );
};

export default PathContent;
